import { gql } from "graphql-tag";

export const INTEREST_DOCUMENTS = gql`
  query FetchInterestDocuments($interestID: ID!) {
    interest(id: $interestID) {
      id
      documents {
        id
        uploadedAt
        url
        downloadUrl
        isPreviewable
        isDeletable
        name
        category
        type
      }
    }
  }
`;

export const REMOVE_DOCUMENT = gql`
  mutation RemoveUploadedDocument($documentId: ID!, $interestId: ID!, $type: DocumentType!) {
    removeDocument(documentId: $documentId, interestId: $interestId, type: $type) {
      id
    }
  }
`;

export const DOCUMENT_PREFLIGHT = gql`
  mutation RequestDocumentPreflights($documents: [DocumentPreflightRequest!]!) {
    documentPreflight(documents: $documents) {
      document {
        id
      }
      tempId
      uploadUrl
    }
  }
`;

export const DOCUMENT_COMPLETE = gql`
  mutation DocumentsUploadComplete($documents: [ID!]!) {
    documentUploadComplete(documents: $documents) {
      id
    }
  }
`;
